import { siteMeta } from "@/mocks/gossipData";

const cols = [
  {
    title: "栏目导航",
    links: [
      { label: "本周焦点", href: "#focus" },
      { label: "瓜料速览", href: "#feed" },
      { label: "近期动态", href: "#timeline" },
      { label: "深度盘点", href: "#special" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "关于我们", href: "#about" },
      { label: "读者口碑", href: "#about" },
      { label: "常见问题", href: "#faq" },
      { label: "订阅瓜报", href: "#subscribe" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-200">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-play text-xl text-primary-600">{siteMeta.brand}</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              {siteMeta.desc}想快速掌握本周最劲爆的瓜料与最新进展，一次看够近期不可错过的热门话题，就锁定 {siteMeta.brand}。
            </p>
            <div className="mt-5 flex gap-3">
              {[
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-douban-line", label: "豆瓣" },
                { icon: "ri-bilibili-line", label: "B站" },
                { icon: "ri-rss-line", label: "RSS" },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#subscribe"
                  aria-label={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-50 text-foreground-600 ring-1 ring-background-300 transition-colors hover:bg-primary-500 hover:text-background-50 hover:ring-primary-500"
                >
                  <i className={s.icon + " text-lg"}></i>
                </a>
              ))}
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="text-sm font-semibold text-foreground-900">{c.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-background-300 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>
            © 2026 {siteMeta.brand} · 本站内容均为编辑整理的信息聚合，部分为虚构演示内容
          </p>
          <p className="flex items-center gap-2">
            <i className="ri-time-line"></i>
            最近更新：{siteMeta.updateTime}
          </p>
        </div>
      </div>
    </footer>
  );
}